import * as Typography from './components/Typography'

import { initEscapeHandler } from './components/EscapeHandler'
initEscapeHandler()

export { accessible, Accessibility } from './components/Accessibility'
export { initFocusHandler } from './components/Accessibility/FocusHandler'

export { accessibleUI } from './components/accessibilityUI'

export * from './components/Accordion'

export * from './components/ActionBar'
export * from './components/ActionBar/typings/ActionBarProps'

export { getCompanyStatusInfo } from './components/CompanyStatus/getCompanyStatusInfo'
export type { CompanyStatusInfo } from './components/CompanyStatus/getCompanyStatusInfo'

export { useContractReasonOptions } from './components/ContractReason'

export { ContractSchedule } from './components/ContractSchedule'

export { useContractStateInfo } from './components/ContractStateInfo'
export { getContractStateInfo } from './components/ContractStateInfo'
export { ContractStateInfoLabel } from './components/ContractStateInfo'
export type { ContractStateInfo } from './components/ContractStateInfo'

export { useContractTypeLabel } from './components/ContractType'

export { createElement } from './components/utils/createElement'

export * from './components/Drawer'
export * from './components/Drawer/providers/DrawerProvider'

export { Divider } from './components/Divider'

export { EmployeeNameTableColumn } from './components/EmployeeNameTableColumn'

export { EditEmployeeGeneralInformationForm } from './components/EditEmployeeGeneralInformationForm'
export { EditEmployeePersonalInformationForm } from './components/EditEmployeePersonalInformationForm'
export { EditEmployeeWageProfileForm } from './components/EditEmployeeWageProfileForm'

export { EmployeeCertificateForm } from './components/EmployeeCertificateForm'

export { EmployeeProfile } from './components/EmployeeProfile'

export * from './components/EmptyState'

export { ErrorState } from './components/ErrorState'

export { EscapeHandler } from './components/EscapeHandler'

export { useGoBack } from './components/goBackTo/hooks/useGoBack'
export { useGoBackTo } from './components/goBackTo/hooks/useGoBackTo'
export { GoBackToEntriesProvider } from './components/goBackTo/providers/GoBackToEntriesProvider'
export { GoBackToProvider } from './components/goBackTo/providers/GoBackToProvider'

export { Grid } from './components/Grid'
export { CheckboxGrid } from './components/Grid/components/CheckboxGrid'

export { useIsVcaExamDateVisible } from './components/hooks/useIsVcaExamDateVisible'
export { useNavigate } from './components/hooks/useNavigate'
export { useNavigateOnPress } from './components/hooks/useNavigateOnPress'

export * from './components/Image'

export { Information } from './components/Information'

export { Layout } from './components/Layout'
export { SIDE_SHEET_DEFAULT_WIDTH } from './components/Layout/components/SideSheet'
export { useIsInLayout } from './components/Layout/hooks/useIsInLayout'

export { Link } from './components/Link'

export { ListView } from './components/ListView/ListView'

export { ListViewItem } from './components/ListView/ListViewItem'

export * from './components/Logo'
export * from './components/Logo/typings/LogoProps'

export { LoadingState } from './components/LoadingState'

export { LoadMoreActivityIndicator } from './components/DEPRECATED/LoadMoreActivityIndicator'

export { NavigationBar } from './components/NavigationBar'

export { OffersTableView } from './components/OffersTableView'

export { CaptureMainNavigate } from './components/MainNavigate/components/CaptureMainNavigate'
export { useMainNavigate } from './components/MainNavigate/hooks/useMainNavigate'
export { MainNavigateProvider } from './components/MainNavigate/providers/MainNavigateProvider'
export type { MainNavigate } from './components/MainNavigate/typings/MainNavigate'
export { MainNavigateGlobalProvider } from './components/MainNavigate/utils/MainNavigateGlobalProvider'

export { Master } from './components/MasterDetail/Master'
export type { MasterProps } from './components/MasterDetail/Master/typings/MasterProps'
export { MasterDetail } from './components/MasterDetail/MasterDetail'
export type { MasterDetailProps } from './components/MasterDetail/MasterDetail/typings/MasterDetailProps'

export { PositionForm } from './components/PositionForm'
export { positionToStep1FormValues } from './components/PositionForm/utils/positionToStep1FormValues'
export { positionToStep2FormValues } from './components/PositionForm/utils/positionToStep2FormValues'
export { positionToStep3FormValues } from './components/PositionForm/utils/positionToStep3FormValues'
export { showEcoChequeFieldsOnPositionForm } from './components/PositionForm/utils/showEcoChequeFieldsOnPositionForm'
export { positionPremiumsToPremiumsFormValues } from './components/PositionForm/steps/Step3/utils/positionPremiumsToPremiumsFormValues'
export type { PositionFormStep1Values } from './components/PositionForm/steps/Step1/typings/PositionFormStep1Values'
export type { PositionFormStep2Values } from './components/PositionForm/steps/Step2/typings/PositionFormStep2Values'

export type { PositionFormStep3Values } from './components/PositionForm/steps/Step3/typings/PositionFormStep3Values'

export * from './components/Premiums'

export { usePreventionServiceOptions } from './components/PreventionService'

export {
  ProgressBar,
  ProgressBarProvider,
  ProgressBarSuspenseFallback,
  useUpdateProgressBar
} from './components/ProgressBar'

export { ProgressIndicator } from './components/ProgressIndicator'

export { Breakpoints } from './components/Responsive'

export { Screen } from './components/Screen'
export type { ScreenProps } from './components/Screen/typings/ScreenProps'
export {
  ScreenTitleProvider,
  useScreenTitle
} from './components/Screen/providers/ScreenTitleProvider'

export { ScrollReveal } from './components/ScrollReveal'
export type { ScrollRevealProps } from './components/ScrollReveal'

export { SearchEmptyState } from './components/Search/SearchEmptyState'

export { useSideSheetConfirmationDialog } from './components/SideSheetConfirmationDialog'

export { SideSheets } from './components/SideSheets'
export { useMaxActiveSideSheetsWidth } from './components/SideSheets/hooks/useMaxActiveSideSheetsWidth'
export { useHasSideSheets } from './components/SideSheets/hooks/useHasSideSheets'
export { useIsInSideSheet } from './components/SideSheets/hooks/useIsInSideSheet'
export { useSideSheetIndex } from './components/SideSheets/hooks/useSideSheetIndex'
export { useSideSheetsHistory } from './components/SideSheets/hooks/useSideSheetsHistory'
export { useSideSheetsNavigator } from './components/SideSheets/hooks/useSideSheetsNavigator'
export {
  getSideSheetsNavigation,
  SideSheetsProvider
} from './components/SideSheets/providers/SideSheetsProvider'
export type { SideSheetsHistory } from './components/SideSheets/typings/SideSheetsHistory'

export { useStatuteLabel } from './components/Statute'

export { margin, type MarginProps } from './components/styles/margin'
export { font, FontWeight } from './components/styles/font'
export { Shadows } from './components/styles/shadows'
export { ZIndex } from './components/styles/zIndex'

export type { SubmitButtonProps } from './components/SubmitButton'
export { SubmitButton } from './components/SubmitButton'

export { SurveyForm } from './components/SurveyForm'

export { useSurveyTypeLabel } from './components/SurveyType'

export {
  InformativeTag,
  RedInformativeTag,
  YellowInformativeTag,
  GreenInformativeTag
} from './components/Tags'

export { Typography }

export {
  Body,
  BodyAlt,
  Caption,
  CaptionAlt,
  Text,
  type TextProps
} from './components/Typography'

export { UnknownErrorPage } from './components/UnknownErrorPage'

export { ViewContractScreenContent } from './components/ViewContractScreenContent'
export { getWorkingTimeFromWorkday } from './components/ViewContractScreenContent/utils/getWorkingTimeFromWorkday'

export { ViewPositionScreenContent } from './components/ViewPositionScreenContent'
export { ViewWorkPostSheetScreenContent } from './components/ViewWorkPostSheetScreenContent'

export { ViewSurveyScreenContent } from './components/ViewSurveyScreenContent'

export * from './components/WorkPostSheetForm'
export { wpsFormValuesToWorkPostSheetInput } from './components/WorkPostSheetForm/utils/wpsFormValuesToWorkPostSheetInput'
export type { WorkPostSheetFormValues } from './components/WorkPostSheetForm/providers/FormProvider'

export { LeftContentContainer } from './components/ActionBar/components/LeftContentContainer'
export { RightContentContainer } from './components/ActionBar/components/RightContentContainer'

export { fileToBase64 } from './utils/fileToBase64'
